module.exports = __webpack_public_path__ + "assets/b50.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b50.png
// module id = 639
// module chunks = 0